import { useTranslation } from 'next-i18next'

export function SearchMobileFacets({ facets }: any) {
  const { t: translate } = useTranslation('common')
  return (
    <label
      className="mobileSearchFacets absolute border text-xs rounded-md block sm:hidden border-white right-10 top-0 z-11 cursor-pointer p-2.5 text-white"
      htmlFor="mobile-menu"
    >
      {translate('text-all-filters')}
      <input className="peer hidden" type="checkbox" id="mobile-menu" />
      <div className="relative z-50 block bg-black bg-transparent before:absolute before:top-[-0.35rem] before:z-50 before:block before:h-full before:w-full before:bg-black before:transition-all before:duration-200 before:ease-out after:absolute after:right-0 after:bottom-[-0.35rem] after:block after:h-full after:w-full after:bg-black after:transition-all after:duration-200 after:ease-out peer-checked:bg-transparent before:peer-checked:top-0 before:peer-checked:w-full before:peer-checked:rotate-45 before:peer-checked:transform after:peer-checked:bottom-0 after:peer-checked:w-full after:peer-checked:-rotate-45 after:peer-checked:transform"></div>
      <div className="fixed inset-0 z-40 hidden h-full w-full bg-black/50 backdrop-blur-sm peer-checked:block">
        &nbsp;
      </div>
      <div className="fixed top-0 right-0 z-40 h-full w-full translate-x-full overflow-y-auto overscroll-y-none transition duration-500 peer-checked:translate-x-0">
        <div className="float-right min-h-full w-[85%] bg-white px-6 pt-12 shadow-2xl mobile-facets text-black">
          {facets}
        </div>
      </div>
    </label>
  )
}
